import React, { useState } from 'react'

import './tooltip.css'

const Tooltip = (props) => {
  let timeout

  const [active, setActive] = useState(false)

  const showTooltip = () => {
    timeout = setTimeout(() => {
      setActive(true)
    }, props.delay || 400)
  }

  const KeyPressTooltip = (e) => {
    if (e.key === 'Enter') {
      setActive(true)
    }
  }

  const hideTooltip = (e) => {
    clearInterval(timeout)

    setActive(false)

    e.stopPropagation()
  }

  return (
    <div
      role="button"
      tabIndex="0"
      className="Tooltip-target u-flexJustifyCenter u-posRelative u-borderNone"
      id={props.id}
      data-analytics="ETF-Info-Button"
      data-analytics-tooltip-name={
        props.heading || props.content.substring(0, 10)
      }
      data-qa-automation="tooltip-open"
      onClick={showTooltip}
      onKeyUp={(e) => KeyPressTooltip(e)}
    >
      {props.children}
      {active && (
        <div
          className={`Tooltip u-marginTop3gu Tooltip-container ${props.direction}`}
          role="tooltip"
        >
          <button
            type="button"
            role="button"
            className="Tooltip-close-btn"
            data-analytics="ETF-Info-Button"
            data-analytics-tooltip-name={
              props.heading || props.content.substring(0, 10)
            }
            data-qa-automation="tooltip-close"
            onClick={(e) => hideTooltip(e)}
          >
            &#x2715;
          </button>
          <div className="Tooltip-content">
            {props.heading && (
              <h3 className="Tooltip-heading">{props.heading}</h3>
            )}
            <p
              className="Tooltip-text u-marginTop1gu"
              dangerouslySetInnerHTML={{ __html: props.content }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Tooltip
